import React, { useEffect, useState } from 'react';
import api from '../utils/axios';
import { Card } from './ui/card';
import { AlertTriangle } from 'lucide-react';

const horaAR = (iso) => {
  try {
    return new Date(iso).toLocaleTimeString('es-AR', {
      hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'America/Argentina/Buenos_Aires',
    });
  } catch {
    return '--:--';
  }
};

export const IngestaSinMovimientosAviso = () => {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.get('/waya-movimientos/config').then((r) => setCfg(r.data)).catch(() => {});
  }, []);

  if (cfg?.last_status !== 'sin_movimientos') return null;
  return (
    <Card className="mb-8 p-5 border-2 border-red-300 bg-red-50" data-testid="home-ingesta-sin-movimientos">
      <div className="flex items-center gap-3">
        <div className="p-2.5 bg-red-600 rounded-lg shrink-0">
          <AlertTriangle className="h-6 w-6 text-white" />
        </div>
        <h3 className="text-lg font-bold text-red-800" data-testid="home-ingesta-sin-movimientos-texto">
          Ingesta: sin movimientos en horario hábil (última corrida {horaAR(cfg.last_run_at)})
        </h3>
      </div>
    </Card>
  );
};
